import Vue from 'vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { PLANNER_API_URL } from '@/config'

const mixins = Vue.mixin({
  computed: {
    ...mapGetters(['progress', 'settings', '_', 'filter', 'favorites', 'key']),
  },
  methods: {
    ...mapMutations(['setProgress', 'setBack', 'setUser', 'setModal']),
    ...mapActions(['getSessions', 'getUser']),
    formatDay(day) {
      return this._.date_format_program
        .replace('&day', this._[day.day_name])
        .replace('&d', day.day)
        .replace('&month', this._[day.month_name]);
    },
    async toggleSession(sval) {
      if (!this.key && !this.flave) {
        this.setModal(true);
        return;
      }
      if (!this.key && this.flave) {
        return;
      }
      await Vue.axios.get(PLANNER_API_URL + '/program/favorites/sessions/' + sval.id, {
        headers: { 'x-api-key': this.key }
      });
      this.setProgress(false);
      if (this.favorites.sessions.find(fav => fav === sval.id)) {
        this.favorites.sessions = this.favorites.sessions.filter(fav => fav !== sval.id);
      } else {
        this.favorites.sessions.push(sval.id);
        sval.presentations.map(presentation => {
          this.favorites.session_presentations = this.favorites.session_presentations.filter(fav => fav !== presentation.id);
        });
      }
    },
    async toggleSessionPresentation(sval, ckey) {
      if (!this.key && !this.flave) {
        this.setModal(true);
        return;
      }
      if (!this.key && this.flave) {
        return;
      }
      const id = sval.presentations[ckey].id;
      if (this.key) {
        await Vue.axios.get(PLANNER_API_URL + '/program/favorites/sessions/' + sval.id + '/presentations/' + id, {
          headers: { 'x-api-key': this.key }
        });
        this.setProgress(false);
      }
      if (this.favorites.sessions.find(fav => fav === sval.id)) {
        this.favorites.sessions = this.favorites.sessions.filter(fav => fav !== sval.id);
        const presentations = sval.presentations.reduce((carry, presentation) => { 
          if (presentation.id !== id && !this.favorites.session_presentations.includes(id)) carry.push(presentation.id);
          return carry; 
        }, []);
        this.favorites.session_presentations = this.favorites.session_presentations.concat(presentations);
      } else if (this.favorites.session_presentations.find(fav => fav === id)) {
        this.favorites.session_presentations = this.favorites.session_presentations.filter(fav => fav !== id);
      } else {
        if (sval.presentations.every(presentation => this.favorites.session_presentations.concat([id]).includes(presentation.id))) {
          sval.presentations.map(presentation => {
            this.favorites.session_presentations = this.favorites.session_presentations.filter(fav => fav !== presentation.id);
          });
          if (!this.favorites.sessions.find(fav => fav === sval.id)) {
            this.favorites.sessions.push(sval.id);
          }
        } else {
          if (this.favorites.sessions.find(fav => fav === sval.id)) {
            this.favorites.sessions = this.favorites.sessions.filter(fav => fav !== sval.id);
          }
          this.favorites.session_presentations.push(id);
        }
      }
    },
    async syncFavorites() {
      const options = {
        params: {
          sessions: this.favorites.sessions,
          presentations: this.favorites.session_presentations,
        },
      };
      if (this.key) options.headers = { 'x-api-key': this.key };
      const favorites = await this.axios.get(PLANNER_API_URL + '/program/favorites', options);
      this.favorites.sessions = (favorites.data && favorites.data.sessions) ? favorites.data.sessions.map(session => session.id) : [];
      this.favorites.session_presentations = (favorites.data && favorites.data.session_presentations) ? favorites.data.session_presentations.map(presentation => presentation.id) : [];
      this.setProgress(false);
    },
  }
})

export default mixins
